import React from 'react';
import {FeedbackTriggerType} from 'records/FeedbackTrigger';
import withRecipients from 'components/triggers/rule-context/WithRecipients';
import ScoresContextView from 'components/triggers/rule-context/ScoresContextView';
import {SmartAlertContextTitle} from 'components/triggers/rule-context/SmartAlertContextTitle';
import {ScorecardIcon} from '@components/icon/ScorecardIcon';

class ScoresContext extends React.Component {
  constructor(props) {
    super(props);
    this.onValueChange = this.onValueChange.bind(this);

    this.getScores = this.getScores.bind(this);
    this.getScoresIndex = this.getScoresIndex.bind(this);

    this.addScoreContext = this.addScoreContext.bind(this);
    this.removeScoreContext = this.removeScoreContext.bind(this);
    this.state = {userContextSelected: false};
  }

  addScoreContext() {
    const scoreIndex = this.getScoresIndex();
    const newContext = this.props.context.updateIn(['matchAll', scoreIndex, 'range'], _ => ({
      start: 0,
      end: 100,
    }));
    this.props.contextChange(newContext);
  }

  removeScoreContext() {
    const scoreIndex = this.getScoresIndex();
    this.props.contextChange(
      this.props.context.updateIn(['matchAll', scoreIndex, 'range'], _ => null)
    );
  }

  getScores() {
    return this.props.context.matchAll.find(item => item.type === FeedbackTriggerType.SCORES);
  }

  getScoresIndex() {
    const comments = this.getScores();
    return this.props.context.matchAll.indexOf(comments);
  }

  onValueChange(range) {
    const scoresIndex = this.getScoresIndex();
    const newContext = this.props.context.setIn(['matchAll', scoresIndex, 'range'], range);
    this.props.contextChange(newContext);
  }

  render() {
    const {usersEmpty, renderEmbeddedContent, showContextButton} = this.props;
    const scores = this.getScores();
    return (
      <div className="context-container">
        <SmartAlertContextTitle onClose={this.props.removeContext} icon={ScorecardIcon}>
          <span>they filled out a scorecard</span>
        </SmartAlertContextTitle>
        <div className={!scores.range && usersEmpty && 'initial-options'}>
          {renderEmbeddedContent()}
          {showContextButton && (
            <ScoresContextView
              context={scores}
              valueChange={this.onValueChange}
              removeItem={this.removeScoreContext}
              addItem={this.addScoreContext}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withRecipients(ScoresContext);
